const schema_paragraphs = [
  'COMMISSION_SCHEME.FIRST_PARAGRAPH',
  'COMMISSION_SCHEME.SECOND_PARAGRAPH',
  'COMMISSION_SCHEME.THIRD_PARAGRAPH',
  'COMMISSION_SCHEME.FOURTH_PARAGRAPH',
  'COMMISSION_SCHEME.FIFTH_PARAGRAPH',
];

const ifs_schema_paragraphs = ['COMMISSION_SCHEME.IFS_FIRST_PARAGRAPH', 'COMMISSION_SCHEME.IFS_SECOND_PARAGRAPH', 'COMMISSION_SCHEME.IFS_THIRD_PARAGRAPH'];

const trading_activity_table = [
  {
    label: 'TRADING_ACTIVITY_TABLE.TRIGGER',
    value: 'TRADING_ACTIVITY_TABLE.TRIGGER_VALUE',
    number: false,
  },
  {
    label: 'TRADING_ACTIVITY_TABLE.GOAL',
    value: '1000000',
    prefix: '$',
    number: true,
  },
  {
    label: 'TRADING_ACTIVITY_TABLE.TIER_1',
    value: '400',
    prefix: '$',
    number: true,
  },
  {
    label: 'TRADING_ACTIVITY_TABLE.TIER_2',
    value: '200',
    prefix: '$',
    number: true,
  },
];

const commission_table = [
  {
    label: 'TRADING_ACTIVITY_TABLE.TRIGGER',
  },
  {
    label: 'COMMISSION_TABLE.LEVEL',
  },
  {
    label: 'TRADING_ACTIVITY_TABLE.TIER_1',
  },
  {
    label: 'TRADING_ACTIVITY_TABLE.TIER_2',
  },
];

const affiliate_table_paragraphs = [
  {
    label: 'COMMISSION_TABLE.FIRST_PARAGRAPH',
  },
  {
    label: 'COMMISSION_TABLE.SECOND_PARAGRAPH',
  },
  {
    label: 'COMMISSION_TABLE.THIRD_PARAGRAPH',
    link: 'https://nagamarkets.eu/achievements/',
  },
  {
    label: 'COMMISSION_TABLE.FOURTH_PARAGRAPH',
    full_profile: true,
  },
  {
    label: 'COMMISSION_TABLE.FIFTH_PARAGRAPH',
    action: true,
    openInfoModal: true,
  },
];

const get_verified_goals = ['GET_VERIFIED_MODAL.EMAIL', 'GET_VERIFIED_MODAL.PHONE', 'GET_VERIFIED_MODAL.ABOUT_ME', 'GET_VERIFIED_MODAL.PROFILE_PHOTO', 'GET_VERIFIED_MODAL.FOLLOW'];

export default {
  schema_paragraphs,
  ifs_schema_paragraphs,
  trading_activity_table,
  commission_table,
  affiliate_table_paragraphs,
  get_verified_goals,
};



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/constants/commission-scheme-constants.js